module.exports = __webpack_public_path__ + "img/customize-assignment.2b749924.png";